/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightUnit = exports.VatType = exports.ValueType = exports.TaxableAddressType = exports.SubscriptionFrequency = exports.SubdivisionType = exports.SourceType = exports.SortOrder = exports.Placement = exports.PickupMethod = exports.PaymentStatus = exports.PaymentOptionType = exports.OrderStatus = exports.OrderApprovalStrategy = exports.LineItemQuantityChangeType = exports.JurisdictionType = exports.ItemTypeItemType = exports.InvoiceStatus = exports.InventoryAction = exports.FulfillmentStatus = exports.DiscountType = exports.DiscountReason = exports.DescriptionLineType = exports.DepositType = exports.DeltaPaymentOptionType = exports.CustomFieldGroup = exports.ChannelType = exports.AttributionSource = exports.ActivityType = void 0;
var ActivityType;
(function (ActivityType) {
    ActivityType["ORDER_REFUNDED"] = "ORDER_REFUNDED";
    ActivityType["ORDER_PLACED"] = "ORDER_PLACED";
    ActivityType["ORDER_PAID"] = "ORDER_PAID";
    ActivityType["ORDER_FULFILLED"] = "ORDER_FULFILLED";
    ActivityType["ORDER_NOT_FULFILLED"] = "ORDER_NOT_FULFILLED";
    ActivityType["ORDER_CANCELED"] = "ORDER_CANCELED";
    ActivityType["DOWNLOAD_LINK_SENT"] = "DOWNLOAD_LINK_SENT";
    ActivityType["TRACKING_NUMBER_ADDED"] = "TRACKING_NUMBER_ADDED";
    ActivityType["TRACKING_NUMBER_EDITED"] = "TRACKING_NUMBER_EDITED";
    ActivityType["TRACKING_LINK_ADDED"] = "TRACKING_LINK_ADDED";
    ActivityType["SHIPPING_CONFIRMATION_EMAIL_SENT"] = "SHIPPING_CONFIRMATION_EMAIL_SENT";
    ActivityType["INVOICE_ADDED"] = "INVOICE_ADDED";
    ActivityType["INVOICE_REMOVED"] = "INVOICE_REMOVED";
    ActivityType["INVOICE_SENT"] = "INVOICE_SENT";
    ActivityType["FULFILLER_EMAIL_SENT"] = "FULFILLER_EMAIL_SENT";
    ActivityType["SHIPPING_ADDRESS_EDITED"] = "SHIPPING_ADDRESS_EDITED";
    ActivityType["EMAIL_EDITED"] = "EMAIL_EDITED";
    ActivityType["PICKUP_READY_EMAIL_SENT"] = "PICKUP_READY_EMAIL_SENT";
    ActivityType["CUSTOM_ACTIVITY"] = "CUSTOM_ACTIVITY";
    ActivityType["MERCHANT_COMMENT"] = "MERCHANT_COMMENT";
    ActivityType["ORDER_CREATED_FROM_EXCHANGE"] = "ORDER_CREATED_FROM_EXCHANGE";
    ActivityType["NEW_EXCHANGE_ORDER_CREATED"] = "NEW_EXCHANGE_ORDER_CREATED";
    ActivityType["ORDER_PARTIALLY_PAID"] = "ORDER_PARTIALLY_PAID";
    ActivityType["DRAFT_ORDER_CHANGES_APPLIED"] = "DRAFT_ORDER_CHANGES_APPLIED";
    ActivityType["SAVED_PAYMENT_METHOD"] = "SAVED_PAYMENT_METHOD";
    ActivityType["AUTHORIZED_PAYMENT_CREATED"] = "AUTHORIZED_PAYMENT_CREATED";
    ActivityType["AUTHORIZED_PAYMENT_CAPTURED"] = "AUTHORIZED_PAYMENT_CAPTURED";
    ActivityType["AUTHORIZED_PAYMENT_VOIDED"] = "AUTHORIZED_PAYMENT_VOIDED";
    ActivityType["REFUND_INITIATED"] = "REFUND_INITIATED";
    ActivityType["PAYMENT_REFUNDED"] = "PAYMENT_REFUNDED";
    ActivityType["PAYMENT_REFUND_FAILED"] = "PAYMENT_REFUND_FAILED";
    ActivityType["REFUNDED_AS_STORE_CREDIT"] = "REFUNDED_AS_STORE_CREDIT";
    ActivityType["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    ActivityType["PAYMENT_CANCELED"] = "PAYMENT_CANCELED";
    ActivityType["PAYMENT_DECLINED"] = "PAYMENT_DECLINED";
    ActivityType["ORDER_PENDING"] = "ORDER_PENDING";
    ActivityType["ORDER_REJECTED"] = "ORDER_REJECTED";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
var AttributionSource;
(function (AttributionSource) {
    AttributionSource["UNSPECIFIED"] = "UNSPECIFIED";
    AttributionSource["FACEBOOK_ADS"] = "FACEBOOK_ADS";
})(AttributionSource = exports.AttributionSource || (exports.AttributionSource = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType["UNSPECIFIED"] = "UNSPECIFIED";
    ChannelType["WEB"] = "WEB";
    ChannelType["POS"] = "POS";
    ChannelType["EBAY"] = "EBAY";
    ChannelType["AMAZON"] = "AMAZON";
    ChannelType["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    ChannelType["WIX_APP_STORE"] = "WIX_APP_STORE";
    ChannelType["WIX_INVOICES"] = "WIX_INVOICES";
    ChannelType["BACKOFFICE_MERCHANT"] = "BACKOFFICE_MERCHANT";
    ChannelType["WISH"] = "WISH";
    ChannelType["CLASS_PASS"] = "CLASS_PASS";
    ChannelType["GLOBAL_E"] = "GLOBAL_E";
    ChannelType["FACEBOOK"] = "FACEBOOK";
    ChannelType["ETSY"] = "ETSY";
    ChannelType["TIKTOK"] = "TIKTOK";
    ChannelType["FAIRE_COM"] = "FAIRE_COM";
})(ChannelType = exports.ChannelType || (exports.ChannelType = {}));
var CustomFieldGroup;
(function (CustomFieldGroup) {
    CustomFieldGroup["UNKNOWN_CUSTOM_FIELD_GROUP"] = "UNKNOWN_CUSTOM_FIELD_GROUP";
    CustomFieldGroup["BUSINESS_DETAILS"] = "BUSINESS_DETAILS";
    CustomFieldGroup["CUSTOMER_DETAILS"] = "CUSTOMER_DETAILS";
    CustomFieldGroup["DOCUMENT"] = "DOCUMENT";
    CustomFieldGroup["FOOTER"] = "FOOTER";
    CustomFieldGroup["OTHER"] = "OTHER";
})(CustomFieldGroup = exports.CustomFieldGroup || (exports.CustomFieldGroup = {}));
var DeltaPaymentOptionType;
(function (DeltaPaymentOptionType) {
    DeltaPaymentOptionType["UNKNOWN_PAYMENT_OPTION"] = "UNKNOWN_PAYMENT_OPTION";
    DeltaPaymentOptionType["FULL_PAYMENT_OFFLINE"] = "FULL_PAYMENT_OFFLINE";
    DeltaPaymentOptionType["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(DeltaPaymentOptionType = exports.DeltaPaymentOptionType || (exports.DeltaPaymentOptionType = {}));
var DepositType;
(function (DepositType) {
    DepositType["UNKNOWN"] = "UNKNOWN";
    DepositType["FLAT"] = "FLAT";
    DepositType["PERCENTAGE"] = "PERCENTAGE";
})(DepositType = exports.DepositType || (exports.DepositType = {}));
var DescriptionLineType;
(function (DescriptionLineType) {
    DescriptionLineType["UNRECOGNISED"] = "UNRECOGNISED";
    DescriptionLineType["PLAIN_TEXT"] = "PLAIN_TEXT";
    DescriptionLineType["COLOR"] = "COLOR";
})(DescriptionLineType = exports.DescriptionLineType || (exports.DescriptionLineType = {}));
var DiscountReason;
(function (DiscountReason) {
    DiscountReason["UNSPECIFIED"] = "UNSPECIFIED";
    DiscountReason["EXCHANGED_ITEMS"] = "EXCHANGED_ITEMS";
})(DiscountReason = exports.DiscountReason || (exports.DiscountReason = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["GLOBAL"] = "GLOBAL";
    DiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    DiscountType["SHIPPING"] = "SHIPPING";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var FulfillmentStatus;
(function (FulfillmentStatus) {
    FulfillmentStatus["NOT_FULFILLED"] = "NOT_FULFILLED";
    FulfillmentStatus["FULFILLED"] = "FULFILLED";
    FulfillmentStatus["PARTIALLY_FULFILLED"] = "PARTIALLY_FULFILLED";
})(FulfillmentStatus = exports.FulfillmentStatus || (exports.FulfillmentStatus = {}));
var InventoryAction;
(function (InventoryAction) {
    InventoryAction["RESTOCK"] = "RESTOCK";
    InventoryAction["DECREASE"] = "DECREASE";
})(InventoryAction = exports.InventoryAction || (exports.InventoryAction = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["Draft"] = "Draft";
    InvoiceStatus["Sent"] = "Sent";
    InvoiceStatus["Processing"] = "Processing";
    InvoiceStatus["Paid"] = "Paid";
    InvoiceStatus["Overdue"] = "Overdue";
    InvoiceStatus["Void"] = "Void";
    InvoiceStatus["Deleted"] = "Deleted";
    InvoiceStatus["PartiallyPaid"] = "PartiallyPaid";
    InvoiceStatus["PartialAndOverdue"] = "PartialAndOverdue";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var ItemTypeItemType;
(function (ItemTypeItemType) {
    ItemTypeItemType["UNRECOGNISED"] = "UNRECOGNISED";
    ItemTypeItemType["PHYSICAL"] = "PHYSICAL";
    ItemTypeItemType["DIGITAL"] = "DIGITAL";
    ItemTypeItemType["GIFT_CARD"] = "GIFT_CARD";
    ItemTypeItemType["SERVICE"] = "SERVICE";
})(ItemTypeItemType = exports.ItemTypeItemType || (exports.ItemTypeItemType = {}));
var JurisdictionType;
(function (JurisdictionType) {
    JurisdictionType["UNDEFINED"] = "UNDEFINED";
    JurisdictionType["COUNTRY"] = "COUNTRY";
    JurisdictionType["STATE"] = "STATE";
    JurisdictionType["COUNTY"] = "COUNTY";
    JurisdictionType["CITY"] = "CITY";
    JurisdictionType["SPECIAL"] = "SPECIAL";
})(JurisdictionType = exports.JurisdictionType || (exports.JurisdictionType = {}));
var LineItemQuantityChangeType;
(function (LineItemQuantityChangeType) {
    LineItemQuantityChangeType["QUANTITY_INCREASED"] = "QUANTITY_INCREASED";
    LineItemQuantityChangeType["QUANTITY_DECREASED"] = "QUANTITY_DECREASED";
})(LineItemQuantityChangeType = exports.LineItemQuantityChangeType || (exports.LineItemQuantityChangeType = {}));
var OrderApprovalStrategy;
(function (OrderApprovalStrategy) {
    OrderApprovalStrategy["DEFAULT"] = "DEFAULT";
    OrderApprovalStrategy["PAYMENT_RECEIVED"] = "PAYMENT_RECEIVED";
    OrderApprovalStrategy["PAYMENT_METHOD_SAVED"] = "PAYMENT_METHOD_SAVED";
})(OrderApprovalStrategy = exports.OrderApprovalStrategy || (exports.OrderApprovalStrategy = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["INITIALIZED"] = "INITIALIZED";
    OrderStatus["APPROVED"] = "APPROVED";
    OrderStatus["CANCELED"] = "CANCELED";
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["REJECTED"] = "REJECTED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var PaymentOptionType;
(function (PaymentOptionType) {
    PaymentOptionType["FULL_PAYMENT_ONLINE"] = "FULL_PAYMENT_ONLINE";
    PaymentOptionType["FULL_PAYMENT_OFFLINE"] = "FULL_PAYMENT_OFFLINE";
    PaymentOptionType["MEMBERSHIP"] = "MEMBERSHIP";
    PaymentOptionType["DEPOSIT_ONLINE"] = "DEPOSIT_ONLINE";
    PaymentOptionType["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(PaymentOptionType = exports.PaymentOptionType || (exports.PaymentOptionType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNSPECIFIED"] = "UNSPECIFIED";
    PaymentStatus["NOT_PAID"] = "NOT_PAID";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    PaymentStatus["FULLY_REFUNDED"] = "FULLY_REFUNDED";
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    PaymentStatus["PENDING_MERCHANT"] = "PENDING_MERCHANT";
    PaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatus["DECLINED"] = "DECLINED";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PickupMethod;
(function (PickupMethod) {
    PickupMethod["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    PickupMethod["STORE_PICKUP"] = "STORE_PICKUP";
    PickupMethod["PICKUP_POINT"] = "PICKUP_POINT";
})(PickupMethod = exports.PickupMethod || (exports.PickupMethod = {}));
var Placement;
(function (Placement) {
    Placement["Unknown"] = "Unknown";
    Placement["Replace"] = "Replace";
    Placement["Before"] = "Before";
    Placement["After"] = "After";
})(Placement = exports.Placement || (exports.Placement = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var SourceType;
(function (SourceType) {
    SourceType["UNKNOWN_SOURCE_TYPE"] = "UNKNOWN_SOURCE_TYPE";
    SourceType["WIX_APP"] = "WIX_APP";
    SourceType["EXTERNAL"] = "EXTERNAL";
    SourceType["ADMIN"] = "ADMIN";
    SourceType["OTHER"] = "OTHER";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType = exports.SubdivisionType || (exports.SubdivisionType = {}));
var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency = exports.SubscriptionFrequency || (exports.SubscriptionFrequency = {}));
var TaxableAddressType;
(function (TaxableAddressType) {
    TaxableAddressType["UNKNOWN_TAXABLE_ADDRESS"] = "UNKNOWN_TAXABLE_ADDRESS";
    TaxableAddressType["BUSINESS"] = "BUSINESS";
    TaxableAddressType["BILLING"] = "BILLING";
    TaxableAddressType["SHIPPING"] = "SHIPPING";
})(TaxableAddressType = exports.TaxableAddressType || (exports.TaxableAddressType = {}));
var ValueType;
(function (ValueType) {
    ValueType["UNKNOWN_VALUE_TYPE"] = "UNKNOWN_VALUE_TYPE";
    ValueType["STRING"] = "STRING";
    ValueType["DATE"] = "DATE";
    ValueType["BOOLEAN"] = "BOOLEAN";
    ValueType["NUMBER"] = "NUMBER";
})(ValueType = exports.ValueType || (exports.ValueType = {}));
var VatType;
(function (VatType) {
    VatType["UNSPECIFIED"] = "UNSPECIFIED";
    VatType["CPF"] = "CPF";
    VatType["CNPJ"] = "CNPJ";
})(VatType = exports.VatType || (exports.VatType = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
    WeightUnit["KG"] = "KG";
    WeightUnit["LB"] = "LB";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
//# sourceMappingURL=types.js.map